import { Checkbox } from "../../../controls"

interface SelectionCheckboxProps {
  checked: boolean
  indeterminate?: boolean
  onChange: (checked: boolean) => void
  className?: string
  onClick?: (e: React.MouseEvent) => void
  disabled?: boolean
}

export function SelectionCheckbox({
  checked,
  onChange,
  className,
  disabled,
}: SelectionCheckboxProps) {
  return (
    <Checkbox
      checked={checked}
      onChange={e => onChange(e.target.checked)}
      className={className}
      disabled={disabled}
    />
  )
}
